import { IconButton, InputAdornment, Stack } from "@mui/material";
import { SearchIcon } from "../Icon";
import { useSearchParams } from "react-router";
import React, { useCallback, useEffect, useState } from "react";
import useDebounce from "../../hooks/useDebounce"; // Custom debounce hook
import {
  encodeParamsFromValues,
  decodeParamsToValues,
} from "../../utils/queryParams";
import StyledTextField from "./StyledTextField";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

const SearchInput = ({ placeHolder = "Search" }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [value, setValue] = useState(() => {
    const decoded = decodeParamsToValues(searchParams, [{ keyName: "search" }]);
    return decoded.search || "";
  });

  const debouncedValue = useDebounce(value, 300);

  // Update URL search param based on debounced value
  useEffect(() => {
    const newParams = encodeParamsFromValues(
      { search: debouncedValue },
      searchParams
    );
    setSearchParams(newParams);
  }, [debouncedValue, searchParams, setSearchParams]);

  // Sync input if searchParams changes externally
  useEffect(() => {
    const decoded = decodeParamsToValues(searchParams, [{ keyName: "search" }]);
    setValue(decoded.search || "");
  }, [searchParams]);

  const updateValue = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  return (
    <Stack sx={{ m: 0, maxWidth: 452, width: "100%" }}>
      <StyledTextField
        id="search"
        value={value}
        onChange={updateValue}
        placeholder={placeHolder}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            {!!value ? (
              <IconButton onClick={() => setValue("")}>
                <ClearRoundedIcon />
              </IconButton>
            ) : null}
          </InputAdornment>
        }
        sx={{
          flexGrow: 1,
          marginTop: 0,
          backgroundColor: "#ffffff",
          "& input": {
            pl: 0,
          },
        }}
      />
    </Stack>
  );
};

export default React.memo(SearchInput);
